import { useState, useEffect } from 'react';
import archiveApi from '../../../api/archiveApi';

export interface ArchiveStats {
  totalDocuments: number;
  validDocuments: number;
  pendingValidation: number;
  expiredDocuments: number;
  byModule: Array<{ name: string; value: number }>;
  byStatus: Array<{ name: string; value: number }>;
  recentDocuments: any[];
}

export const useArchiveDashboard = () => {
  const [stats, setStats] = useState<ArchiveStats>({
    totalDocuments: 0,
    validDocuments: 0,
    pendingValidation: 0,
    expiredDocuments: 0,
    byModule: [],
    byStatus: [],
    recentDocuments: [],
  });
  const [loading, setLoading] = useState(true);

  const loadDashboard = async () => {
    try {
      const documents = await archiveApi.getAllDocuments();

      const validDocs = documents.filter(d => d.status === 'valid');
      const pendingDocs = documents.filter(d => d.validation_status === 'pending');
      const expiredDocs = documents.filter(d => d.status === 'expired');

      // By Module
      const moduleCount: Record<string, number> = {};
      documents.forEach(doc => {
        const moduleType = doc.module_type || 'GENERAL';
        moduleCount[moduleType] = (moduleCount[moduleType] || 0) + 1;
      });
      const byModule = Object.entries(moduleCount).map(([name, value]) => ({
        name,
        value,
      }));

      // By Status
      const statusCount: Record<string, number> = {};
      documents.forEach(doc => {
        const status = doc.status || 'draft';
        statusCount[status] = (statusCount[status] || 0) + 1;
      });
      const byStatus = Object.entries(statusCount).map(([name, value]) => ({
        name:
          name === 'valid'
            ? 'Valid'
            : name === 'pending_validation'
              ? 'Pending'
              : name === 'expired'
                ? 'Expired'
                : name === 'draft'
                  ? 'Draft'
                  : 'Rejected',
        value,
      }));

      setStats({
        totalDocuments: documents.length,
        validDocuments: validDocs.length,
        pendingValidation: pendingDocs.length,
        expiredDocuments: expiredDocs.length,
        byModule,
        byStatus,
        recentDocuments: documents.slice(0, 5),
      });
    } catch (error) {
      console.error('Error loading dashboard:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadDashboard();
  }, []);

  return { stats, loading, loadDashboard };
};
